<template>
  <div class="my-center-wrap">
    <VCarousel/>
    <div class="my-center">
      <div class="my-info box">
        <img src="../../assets/avatar.png" alt class="avatar">
        <div class="info-form">
          <div class="input-wrap">
            <label>手机</label>
            <!-- <input type="text" v-model="userInfo.PhoneNumber"> -->
            <p>
              <span>{{userInfo.PhoneNumber}}</span>
              <span class="modTip"></span>
            </p>
          </div>
          <!-- <div class="input-wrap">
            <label>微信</label>
            <input type="text" v-model="userInfo.WechatNickName">
          </div>-->
          <div class="input-wrap">
            <label>邮箱</label>
            <input type="text" v-model="userInfo.Email">
          </div>
          <div class="input-wrap">
            <label>职业</label>
            <input type="text" v-model="userInfo.Profession">
          </div>
          <div class="input-wrap">
            <label>单位</label>
            <input type="text" v-model="userInfo.WorkSpace">
          </div>
        </div>
        <button class="pr-btn dark-btn" @click="saveUserInfo">保存</button>
      </div>
      <div class="my-pay box">
        <div class="pay-form">
          <h4>已购信息</h4>
          <div class="table-wrap">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="ProductName" label="产品名称"></el-table-column>
              <!-- <el-table-column prop="PhoneNumber" label="购买人手机号"></el-table-column> -->
              <el-table-column prop="VipStartTimeStr" label="生效时间"></el-table-column>
              <el-table-column prop="VipExpireTimeStr" label="到期时间"></el-table-column>
              <el-table-column prop="PayTimeStr" label="购买日期"></el-table-column>
              <el-table-column prop="Status" label="状态"></el-table-column>
              <el-table-column prop="ProductPrice" label="价格(元)"></el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button @click="goBuy(scope.$index)" type="text" size="small">续费</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VCarousel from '@/components/VCarousel.vue'

export default {
  name: 'my-center',
  components: {
    VCarousel
  },
  data() {
    return {
      tableData: [],
      userInfo: {
        Email: '',
        PhoneNumber: '',
        Profession: '',
        WechatNickName: '',
        WorkSpace: ''
      }
    }
  },
  methods: {
    goBuy(index) {
      console.log(index)
      this.$router.push({ path: '/pay/' })
    },
    getInfo() {
      const params = {
        pageIndex: 1,
        pageSize: 50
      }
      this.$store.dispatch('GetUserInfo', params).then(res => {
        this.tableData = res.Data.PurchaseShowModel
        this.userInfo = { ...this.userInfo, ...res.Data.UserShowInfo }
      })
    },
    saveUserInfo() {
      this.$store.dispatch('SaveUserInfo', this.userInfo).then(res => {
        this.$message({
          message: '保存成功',
          type: 'success'
        })
      })
    }
  },
  created() {
    this.getInfo()
  }
}
</script>
<style lang="less" scoped>
.my-center {
  background: #f8f9fb;
  padding: 40px 0;
  .box {
    width: 90%;
    background: #ffffff;
    border-radius: 2px;
    padding: 36px 0;
    margin: 0 auto 40px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.my-info {
  text-align: center;
  .avatar {
    width: 93px;
    height: 93px;
    margin-bottom: 30px;
  }
  .info-form {
    width: 70%;
    margin: 0 auto;
  }
  .input-wrap {
    margin-bottom: 18px;
    text-align: left;
    display: flex;
    align-items: center;
    label {
      font-size: 16px;
      line-height: 22px;
      color: #a4a8ab;
      margin-right: 20px;
      min-width: 32px;
    }
    input {
      flex-grow: 1;
      height: 32px;
      background: rgba(246, 248, 250, 1);
      border-radius: 2px;
      border: 1px solid rgba(228, 231, 237, 1);
      padding-left: 10px;
    }
    .modTip {
      color: rgba(29, 29, 29, 0.4);
    }
  }
  .dark-btn {
    font-size: 16px;
    line-height: 22px;
    border-radius: 2px;
    font-weight: 400;
  }
}
.my-pay {
  .pay-form {
    width: 70%;
    margin: 0 auto;
  }
  h4 {
    color: #1d1d1d;
    margin-bottom: 14px;
    font-size: 16px;
    line-height: 22px;
  }
  .table-wrap {
    border-radius: 2px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
  }
}
@media screen and (max-width: 990px) {
  .my-info {
    .info-form {
      width: 90%;
    }
  }
  .my-pay {
    .pay-form {
      width: 90%;
    }
  }
}
</style>
